module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter43"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block59"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h160"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Travis")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p2843"
    }
  }, [_vm._v("If there is one thing I’ve learned from my former coaches, it’s to always be honorable. To show respect, even in situations where it may not be shown toward me in return. I may not always be this way, especially when it comes to women, but you can bet your ass I am when it comes to Boston’s finest. So when I answered someone knocking on my front door and the man dressed in a suit introduces himself as Detective Hook and asks for a minute of my time, I let him in.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2844"
    }
  }, [_vm._v("Maybe if I had known what he wanted when he was standing on my stoop, I wouldn’t be here right now. Here, being the Boston precinct, where people who were in the drunk tank are calling my name out, and the officers I pass are asking what my predictions will be for next season.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2845"
    }
  }, [_vm._v("Detective Hook leads me down the hall and into a box-shaped room. Now, in the off-season, I watch a lot of television, with crime shows being my favorite, and I can tell you that this interrogation room looks nothing like the ones in Hollywood. It’s dark, drab, and doesn’t even have a small window. Also missing is the two-way glass I’d really like to see.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2846"
    }
  }, [_vm._v("Hook motions for me to sit down and pulls out his chair. I cringe at the sound of the metal legs scraping against the flooring. As I sit in the metal chair with a ripped seat cushion that is missing half the foam insert, the errant pieces of vinyl dig into my legs through my track pants. In hindsight, I probably should’ve changed my clothes or grabbed something to eat before coming here.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2847"
    }
  }, [_vm._v("“Mr. Kidd, I want to first thank you for coming down here.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2848"
    }
  }, [_vm._v("“Please, call me Travis.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2849"
    }
  }, [_vm._v("Hook nods, opens his folder, and silently reads over a sheet of paper before closing the folder. He pushes it aside, and then he slides a yellow legal pad in front of him, folding his hands, while smiling at me. It’s all very mechanical, and if I didn’t know better, I’d think this is a speed-dating course. I did that once for the hell of it. Some guy taught us how to pick up chicks in under three minutes. I don’t know if it was successful or not. Most of the women figured out who I was and rang their bell.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2850"
    }
  }, [_vm._v("“Travis, I’m going to ask you a few questions, and please remember that you can leave at any time. Can you tell me where you were last night around eleven thirty?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2851"
    }
  }, [_vm._v("I scratch my head, not out of confusion, but habit. “I think I was home.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2852"
    }
  }, [_vm._v("“You think?” Hook picks up the pen that is sitting next to the folder and leans back in his chair. He depresses the button repeatedly, filling the room with that annoying clicking noise.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2853"
    }
  }, [_vm._v("As if it’s an automatic response, my shoulders shrug, and I nod.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2854"
    }
  }, [_vm._v("“But you’re not sure?” Hook sets his pen down and folds his hands together.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2855"
    }
  }, [_vm._v("By the way he’s looking at me, something in the back of my mind is telling me that I really shouldn’t be here, that volunteering to come down to the station to chat was a mistake.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2856"
    }
  }, [_vm._v("“Am I in some sort of trouble?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2857"
    }
  }, [_vm._v("“Travis, do you know Rachel Ward?” Hook asks. As I shake my head, he opens the folder and pulls out an image, sliding it over to me with his finger pinning it to the table.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2858"
    }
  }, [_vm._v("“I met her last night, but uh…she introduced herself as Blue.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2859"
    }
  }, [_vm._v("“Blue?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2860"
    }
  }, [_vm._v("“Yeah, we shot a few games of pool. Had some beer.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2861"
    }
  }, [_vm._v("“Anything else?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2862"
    }
  }, [_c('i', [_vm._v("This is where you keep your mouth shut, Kidd. ")]), _vm._v("“We kissed a little.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2863"
    }
  }, [_vm._v("“And where did you take Ms. Ward when you left the bar?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2864"
    }
  }, [_vm._v("I shake my head. “Nowhere.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2865"
    }
  }, [_vm._v("“Are you sure about that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2866"
    }
  }, [_vm._v("“Yeah, I am. Did she say she was with me? Did she do something wrong?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2867"
    }
  }, [_vm._v("Hook takes the photo and places it back into his folder. “No, Travis. Ms. Ward went to the emergency room last night and informed the nurse that she had been raped…” Hook lets that sink in for a minute before he goes in for the kill. “By you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2868"
    }
  }, [_vm._v("My back pushes into my chair as if a bucket of bricks has been thrown at my chest. The imaginary force causes my breathing to labor and my fists to clench. I shake my head as I try to regain my composure. I didn’t touch that woman once I left the bar. In fact, we never left the general bar area together, so how can she say something like this?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2869"
    }
  }, [_vm._v("“Nah, man. She’s lying. It wasn’t me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2870"
    }
  }, [_vm._v("“Travis—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2871"
    }
  }, [_vm._v("I put my hand up to stop him. It’s disrespectful, I know, but I’m not answering any more of his questions. “I think I need to wait for my lawyer.” With his cold, dark eyes focusing on me, Hook picks up the folder and taps it a few times on the table before pushing his chair back. The nerve-grating sound of the legs pushing into the floor from his body weight sends a warning signal to me: "), _c('i', [_vm._v("He’s pissed and thinks I’m guilty of rape.")])]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration6"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p2872"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p2873"
    }
  }, [_vm._v("“Travis?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2874"
    }
  }, [_vm._v("My head pops up when I hear my name. Irvin walks in. Our eye contact is brief, and I can see it in his eyes. I know his question before he even has to say it, and I hate that I’ve put the doubt in his mind. “No, I didn’t. I left by myself, but someone saw me leave.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2875"
    }
  }, [_vm._v("Irvin sighs and sets his briefcase and jacket onto the table. “I already called Jeffrey. He’s sending someone over.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2876"
    }
  }, [_vm._v("“Why?” I ask. I don’t see why my public relations manager needs to be involved. I didn’t do anything wrong, so Irvin should be able to get everything taken care of, and I can be on my way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2877"
    }
  }, [_vm._v("“Because you’re Travis Kidd and you’re sitting in a police station. Whether you committed a crime or not, you’re newsworthy, and the district attorney will use the media to his advantage to get them on his side.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2878"
    }
  }, [_vm._v("“But I didn’t "), _c('i', [_vm._v("do")]), _vm._v(" anything!” I say rather loudly with my hands in the air.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2879"
    }
  }, [_vm._v("“They don’t seem to think that’s the case, Travis. I’ve already met with Detective Hook, and he’s certain that the case he’s building is going to be solid. He wants to talk.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2880"
    }
  }, [_vm._v("I let my head fall forward, already feeling defeated. “So now what?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2881"
    }
  }, [_vm._v("Irvin sits down and pulls out his legal pad, much like the detective. “We’re going to get your story, speak with Hook, and let Jeffrey’s team take care of the media.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2882"
    }
  }, [_vm._v("The door opens suddenly, and my eyes open wide as I take in Saylor, dressed similarly to the way I saw her last night, except now she’s in work mode. I groan internally, wishing that Jeffrey would’ve come himself and not sent her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2883"
    }
  }, [_vm._v("“The media is preparing for something big. Jeffrey said you plan to speak on Travis’s behalf after the DA gives his press conference?” Saylor states.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2884"
    }
  }, [_vm._v("Saylor all but ignores me and focuses on Irvin. This is how things should be, right? The people I pay to protect me, doing their job?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2885"
    }
  }, [_vm._v("“Of course. I’m not going to allow the DA to railroad my client,” Irvin says, and she nods, finally looking at me, although it’s brief.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2886"
    }
  }, [_vm._v("There’s a quick knock on the door, and Hook walks back in and takes a seat across from me and next to Saylor. There’s a tinge of jealousy coursing through me that he gets to be next to her and I can’t.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2887"
    }
  }, [_vm._v("“Travis, now that you’re in the company of your lawyer and—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2888"
    }
  }, [_vm._v("“My public relations team,” I say, interrupting him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2889"
    }
  }, [_vm._v("“Right,” he says, sighing. I’m sure he doesn’t like dealing with athletes, but I have to protect every side of my life here, and the last thing I need is a scandal. Saylor can, and will, prevent that. “Tell me about last night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2890"
    }
  }, [_vm._v("Instantly, I look at Saylor, who peers down at the table, avoiding eye contact with me. I shake my head and start. “I met Blue while I was in the bar. We shot a few games of pool. I let her think she was hustling me, so she won a few games. We kissed a few times, but I ran into a friend, and when she left, I did as well.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2891"
    }
  }, [_vm._v("“And Ms. Ward?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2892"
    }
  }, [_vm._v("I shrug. “I left her standing on the side of the road. I was more interested in my friend.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2893"
    }
  }, [_vm._v("“And who is this friend?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2894"
    }
  }, [_vm._v("Once again I seek out Saylor. She shakes her head slightly, confusing me. “Um…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2895"
    }
  }, [_vm._v("“Do you know her name?” Hook asks as he slides the yellow legal pad over to me with a pen resting on top.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2896"
    }
  }, [_vm._v("I can feel everyone’s eyes on me, and I’m afraid to look back at Saylor out of fear that I’ll give her away before we have a chance to talk about last night. “I need to talk to her first. I, uh…I can’t do this to her without some warning.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2897"
    }
  }, [_vm._v("“Do what, exactly?” Hook asks.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2898"
    }
  }, [_vm._v("I wave my hand dismissively. “The attention that is sure to come with being tied to something like this.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2899"
    }
  }, [_vm._v("“Travis, it’ll help if you give them her name. We can protect her. Besides, she’s not the one facing this accusation. You are, and let’s face it, your reputation isn’t going to help you here,” Irvin says.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2900"
    }
  }, [_vm._v("I process his words, knowing he’s right. Another glance at Saylor, though, and I can see torment written all over her face. Something isn’t right with her, and I want to know what it is.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2901"
    }
  }, [_vm._v("“Was a rape kit done?” Irvin asks, steering the question away from me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2902"
    }
  }, [_vm._v("“Yes; we’re waiting for the results.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2903"
    }
  }, [_vm._v("“Great. Let us know when it comes in. Until then, we’re done talking.” Irvin and Saylor stand and motion for me to do as well. I follow them out and right into a media shit storm. The second the doors are opened, microphones are thrust into my face. The DA looks smug and pretentious as he glares at me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2904"
    }
  }, [_vm._v("Questions are thrown at me right and left, most of which I can’t even comprehend. Every time I hear the word "), _c('i', [_vm._v("rape")]), _vm._v(", I die a little on the inside. I don’t have to force myself onto anyone, and I definitely know what "), _c('i', [_vm._v("no")]), _vm._v(" means.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2905"
    }
  }, [_vm._v("Two police officers appear out of nowhere and try to put some distance between the crowd and us. Irvin holds his hand up, and microphones are pointed in his direction.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2906"
    }
  }, [_vm._v("“We know you have questions, and while it seems that the state’s attorney feels like he has an open-and-shut case, I assure you no charges have been filed. My client was here to answer questions and came in willingly. He was not, and has not been, arrested.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2907"
    }
  }, [_vm._v("Irvin motions for us to leave. One of the officers leads us down the stairs while the other follows behind us. A black town car is waiting at the bottom of the steps for us to climb into. Once the door shuts, we speed off. While Saylor and Irvin talk about what happens next, my life, my career, and everything that I know flash before my eyes, and I don’t like what I’m seeing.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793a9c00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s007-Chapter-003.vue
// module id = 78
// module chunks = 0